module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terminalmanagement"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("端管理")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', [_c('a-button', {
    staticStyle: {
      "width": "96px",
      "margin-bottom": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newterminalbtn
    }
  }, [_vm._v("新增端")]), _vm._v(" "), _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("端名称")])], 1)], 1), _vm._v(" "), (!_vm.terminallist.length) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.terminallist), function(terminal) {
    return (_vm.terminallist.length) ? _c('div', {
      key: terminal.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 12
      }
    }, [_vm._v(_vm._s(terminal.id))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 12
      }
    }, [_vm._v(_vm._s(terminal.terminal_name))])], 1)], 1) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "新增商品",
      "visible": _vm.terminalvisible,
      "confirmLoading": _vm.confirmLoading
    },
    on: {
      "ok": _vm.terminalOk,
      "cancel": _vm.terminalCancel
    }
  }, [_c('div', {
    staticClass: "newterminal"
  }, [_c('span', {
    staticClass: "newterminaltext"
  }, [_vm._v("端名称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入端名称"
    },
    model: {
      value: (_vm.newterminal.terminal_name),
      callback: function($$v) {
        _vm.$set(_vm.newterminal, "terminal_name", $$v)
      },
      expression: "newterminal.terminal_name"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25854559","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/sale/terminalmanagement/index.vue
// module id = 2371
// module chunks = 1